/** @jsxImportSource @emotion/react */
import { backofficeDocumentation } from './documentation';

export const Backoffice = () => {
  return (
    <>
      {backofficeDocumentation.map((doc) => (
        <div id={doc.id} key={doc.id}>
          {doc.content}
        </div>
      ))}
    </>
  );
};
